<div class="confirmation-dialog">
  <div class="flex items-center">
    <div class="mr-3">
      <ic-icon [icon]="icWarning" class="text-amber-500" size="24px"></ic-icon>
    </div>
    <h2 mat-dialog-title class="headline m-0 pr-6 flex-auto">Affectations manquantes</h2>
    <button class="text-secondary" mat-dialog-close type="button" mat-icon-button>
      <ic-icon [icon]="icClose"></ic-icon>
    </button>
  </div>

  <mat-dialog-content class="content">
    <!-- Message d'erreur principal -->
    <div class="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
      <p class="text-secondary text-base mb-0">
        {{ data.message }}
      </p>
    </div>

    <!-- Information complémentaire -->
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <h3 class="text-lg font-semibold text-blue-800 mb-2 flex items-center">
        <ic-icon [icon]="icWarning" class="mr-2" size="20px"></ic-icon>
        Que faire ?
      </h3>
      <p class="text-sm text-gray-700">
        Pour accéder au périmètre des engagements, vous devez avoir au moins un établissement affecté à votre profil
        utilisateur.
      </p>
    </div>

    <!-- Note -->
    <div class="mt-4 text-sm text-gray-600">
      <p>
        <strong>Note :</strong>
        Vous pouvez vérifier vos affectations en consultant votre profil utilisateur ou contacter votre administrateur
        pour obtenir les accès nécessaires.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="actions">
    <button mat-button type="button" (click)="close()" class="mr-4">Fermer</button>
    <button mat-flat-button color="primary" type="button" (click)="goToUserProfile()">
      <ic-icon [icon]="icPerson" class="mr-2" inline="true" size="20px"></ic-icon>
      Voir mon profil
    </button>
  </mat-dialog-actions>
</div>
